import { Divider, Grid, Row, Space } from 'antd'
import DeliveryPrices from 'app/components/Core/DeliveryItem/Prices'
import InsuranceAndOtherPrices from 'app/components/Core/LineItem/Price/InsuranceAndOther'
import LineItemMachinePrices from 'app/components/Core/LineItem/Price/Machine'
import RentalPriceInfo from 'app/components/Core/Rental/Price/Info'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useQuery } from 'app/lib/hooks/useQuery'
import * as rentals from 'app/queries/Rentals'
import React from 'react'
import { useParams } from 'react-router-dom'

const RentalCheckoutPrices: React.FC = () => {
  const { md } = Grid.useBreakpoint()
  const { checkout_id } = useParams<{ checkout_id: string }>()
  const {
    data: { rental },
    loading
  } = useQuery<{ rental: IRental }>(rentals.RENTAL_LINE_ITEMS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      id: checkout_id
    }
  })

  return (
    <Row gutter={[0, 24]}>
      <If condition={md}>
        <KCol span={24} loading={loading}>
          <LineItemMachinePrices
            collection={rental?.lineItems?.filter((i) => i.lineItemType === 'product')}
          />
        </KCol>
        <KCol span={24}>
          <Divider className="my-0" />
        </KCol>
      </If>
      <If condition={rental?.deliveryMethod === 'delivery'}>
        <KCol span={24} loading={loading}>
          <DeliveryPrices collection={rental?.deliveries} />
        </KCol>
        <KCol span={24}>
          <Divider className="my-0" />
        </KCol>
      </If>
      <KCol span={24} loading={loading}>
        <InsuranceAndOtherPrices collection={rental?.lineItems} />
      </KCol>
      <KCol span={24}>
        <Divider className="my-0" />
      </KCol>
      <If condition={rental}>
        <KCol span={24} loading={loading}>
          <Space size={0} direction="vertical" className="full-width">
            <RentalPriceInfo member={rental} props={{ attribute: 'priceNetTotal' }} />
            <RentalPriceInfo member={rental} props={{ attribute: 'priceTaxTotal' }} />
            <RentalPriceInfo member={rental} props={{ attribute: 'priceGrossTotal', bold: true }} />
          </Space>
        </KCol>
      </If>
      <KCol span={24} />
    </Row>
  )
}

export default RentalCheckoutPrices
